<div class="section" *ngIf="isEditable()">
    <div class="title" i18n="security title|Security title into profile page@@securityTitleProfilePage">Security</div>
    <div class="content">
      <div class="col security">
        <button  mat-flat-button color="primary"
                (click)="openChangePasswordWizard()"
                i18n="update pass button|Update pass button into profile page@@updatePassButtonProfilePage">
          UPDATE PASSWORD
        </button>
      </div>
    </div>
</div>
